export const automedicFeaturesKey = 'automedicView';
